import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CargosGestionAcademicaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CargosGestionAcademicaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCargosGestionAcademicaService(): Observable<BodyListResponse<CargosGestionAcademicaDTO>> {
    return this.http.get<BodyListResponse<CargosGestionAcademicaDTO>>(API_URL + '/api/v1/cargosGestionAcademica/todos');
  }

  guardarCargosGestionAcademicaService(cargosGestionAcademicaDTO: CargosGestionAcademicaDTO): Observable<CargosGestionAcademicaDTO> {
    return this.http.post<CargosGestionAcademicaDTO>(API_URL + '/api/v1/cargosGestionAcademica', cargosGestionAcademicaDTO);
  }

  getCargosGestionAcademicaPorCodigoCargoGestionAcademicaService(codigoCargoGestionAcademica: string): Observable<BodyResponse<CargosGestionAcademicaDTO>> {
    return this.http.get<BodyResponse<CargosGestionAcademicaDTO>>(API_URL + '/api/v1/cargosGestionAcademica/' + codigoCargoGestionAcademica);
  }
}
